import React from 'react'
import Header from '../../Components/Header/Header'
import Footer from '../../Components/Footer/Footer'
import img1 from '../../assets/course/12101001.jpg'
import img2 from '../../assets/course/12101002.jpg'
import img3 from '../../assets/course/12101003.jpg'
import tr1 from '../../assets/others/11102067.webp'
import img4 from '../../assets/others/11102069.jpg'
import Accordion from 'react-bootstrap/Accordion'
import Companysec from '../../Components/Companysec/Companysec'
import Offersec from '../../Components/Offersec/Offersec'
import icncheck from '../../assets/icons/check-circle-bl.svg'
import instimg from '../../assets/others/11102038.jpg'
import Enrollaction from '../../Components/Enrollaction/Enrollaction'
import "react-multi-carousel/lib/styles.css";
import Partnersec from '../../Components/Partnersec/Partnersec'
import Videoreview from '../../Components/Videoreviewsec/Videoreview'
import { Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import Whysec from '../../Components/Whysec/Whysec'
library.add(fas)

const onButtonpdf = () => {
    const pdfUrl = "../../brochuer/Design-For-Test-Brochure.pdf";
    window.open(pdfUrl);
};

const DFT = () => {
    const faqSchema={
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is the VLSI Design for Test (DFT) course all about?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our VLSI Design for Test class explores testing complex chip designs to guarantee they are free of defects. You will be taught how to identify and solve problems in systems on Chips (SoCs) by implementing methods such as SCAN, ATPG, JTAG, and MBIST. Perfect for individuals who want to develop chips with built-in testing capabilities."
      }
    },
    {
      "@type": "Question",
      "name": "Who is suitable for the DFT training program?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our DFT training program is ideal for individuals who have completed a B.E. or B. Tech in ECE or EEE, or for those who hold a postgraduate degree in VLSI or Embedded Systems or Digital Electronics. If you want to learn advanced testing methods in VLSI and are interested, this course is suitable for you."
      }
    },
    {
      "@type": "Question",
      "name": "What can I expect from the Design for Test certification?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "You will receive the Design for Test certification after completing the course, which will confirm your proficiency in Design for Test. It indicates that you have successfully mastered crucial test techniques, such as SCAN and ATPG, and are prepared to confidently take on actual chip design problems."
      }
    },
    {
      "@type": "Question",
      "name": "How does the Advanced DFT training differ from basic training?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our advanced DFT training develops a deeper understanding of complex testing structures and methods. You will gain practical experience with advanced tools and projects, ensuring you not only have theoretical knowledge about the concepts but are also proficient in applying them to innovative designs."
      }
    },
    {
      "@type": "Question",
      "name": "Where can I find Design for Test tutorials and resources?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "In our course materials, you can access various videos and resources for Design for Test tutorials. We provide all the essential resources for learning DFT, such as thorough, 24/7, continuous lab support. Furthermore, our skilled teachers will constantly assist you with any issues you may encounter."
      }
    },
    {
      "@type": "Question",
      "name": "How does the DFT training program prepare me for the industry?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Our DFT course details focus on practical knowledge and prepare you for the industry through real projects, real-life situations, and expert advice. You will gain experience from professionals with over 12 years of experience while working on projects that meet industry standards. Furthermore, we provide full support in securing a job in the VLSI design industry to help you achieve your career goals."
      }
    }
  ]
};

    const courseSchema={
  "@context": "https://schema.org",
  "@type": "Course",
  "@id": "https://www.takshila-vlsi.com/design-for-test/#course",
  "name": "Design For Test (DFT) Training Course",
  "description": "Design For Test (DFT) training course covering Scan Insertion, JTAG, ATPG, fault models, pattern generation, simulation, debugging and industry-standard DFT project execution with hands-on training.",
  "url": "https://www.takshila-vlsi.com/design-for-test/",
  "provider": {
    "@type": "Organization",
    "name": "Takshila VLSI",
    "url": "https://www.takshila-vlsi.com/",
    "logo": {
      "@type": "ImageObject",
      "url": "https://www.takshila-vlsi.com/static/media/Logo-2.8ea769c5a593c38a2ba7.jpg"
    },
    "email": "info@takshila-vlsi.com",
    "telephone": "+91-9742972744"
  },
  "coursePrerequisites": "B.E/B.Tech in ECE/EEE, or M.E/M.Tech/M.S in VLSI, Embedded Systems or Digital Electronics.",
  "timeRequired": "P5M",
  "hasCourseInstance": {
    "@type": "CourseInstance",
    "courseMode": [
      "Online",
      "Offline"
    ],
    "location": [
      {
        "@type": "Place",
        "name": "Bengaluru"
      },
      {
        "@type": "Place",
        "name": "Hyderabad"
      }
    ],
    "courseWorkload": "P5M"
  },
  "instructor": {
    "@type": "Person",
    "name": "Mr. Siva",
    "jobTitle": "Specialist Design For Test (DFT)"
  },
  "about": [
    "Design For Testability",
    "DFT",
    "Scan Insertion",
    "JTAG / Boundary Scan",
    "Automatic Test Pattern Generation",
    "ATPG",
    "ATPG Fault Models",
    "Pattern Generation",
    "DFT Simulation",
    "ASIC Design",
    "Verilog"
  ],
  "teaches": [
    "Introduction to Electronics, MOSFET & CMOS Theory",
    "Digital Electronics",
    "Basics of UNIX/LINUX",
    "Introduction to ASIC Design",
    "Introduction to Verilog",
    "Scan Insertion",
    "JTAG / Boundary Scan",
    "Automatic Test Pattern Generation (ATPG)",
    "ATPG Fault Models Fault Classes",
    "Pattern Generation & Simulation",
    "Debugging Simulation Mismatches",
    "Industry Standard Project Execution",
    "Mock Interviews & Personality Development"
  ]
};

  return (
          <div>
          <Helmet>
          <title>Design for Test (DFT) VLSI Training Course & Fees | Takshila VLSI</title>
            <meta name="description" content="Join DFT training to master scan insertion, ATPG, and BIST through practical learning, live projects, and placement assistance with Takshila VLSI." />
            <link rel="canonical" href="https://www.takshila-vlsi.com/product/design-for-test/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="Design for Test (DFT) VLSI Training Course & Fees | Takshila VLSI" />
            <meta property="og:description" content="Join DFT training to master scan insertion, ATPG, and BIST through practical learning, live projects, and placement assistance with Takshila VLSI." />
            <meta property="og:url" content="https://www.takshila-vlsi.com/product/design-for-test/" />
            <meta property="og:site_name" content="Takshila VLSI" />
            <meta property="article:modified_time" content="2024-08-08T06:54:28+00:00" />
            <meta property="og:image" content="https://www.takshila-vlsi.com/wp-content/uploads/2019/12/Desig-for-Test.jpg" />
            <meta property="og:image:width" content="1000" />
            <meta property="og:image:height" content="741" />
            <meta property="og:image:type" content="image/jpeg" />
            <meta name="twitter:card" content="summary_large_image" />

            <script type="application/ld+json">
                {JSON.stringify(faqSchema)}
                </script>
                <script type="application/ld+json">
                {JSON.stringify(courseSchema)}
                </script>
          </Helmet>
          <Header/>
      <main>
          <section class="section-banner pg-banner ws-section pt-5 bg-14">
          <div class="container text-center">
                      <div class="row justify-content-around p-lg-5 pb-0">
                          <div class="col-md-9">
                              <div class="pg-title-sec">
                                  <h1 className='pg-title pb-3'>Design For Test 
                                  <span className='bg-txt mx-3'>DFT</span> 
                                  </h1>
                                  <p className='pg-title-desc mb-5'>Takshila VLSI institute is among the top 10 VLSI training institutes in India. At Takshila, we understand the changing demands in the field of VLSI.</p>
                              </div>
                          </div>
                          <div class="col-md-12 align-self-center mb-3">
                                  <a href="/register-now">
                                      <button class="btn-primary btn-icon">Enroll Now<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                                  </a>
                          </div>
                      </div>
                      <div class="row justify-content-center img-radius g-3">
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img1} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-8 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners feel more confident when applying for jobs</p>
                              </div>
                          </div>
                          <div class="col-md-3 align-self-end">
                          <img src={img2} alt=''/>
                          </div>
                          <div class="col-md-2 align-self-end">
                          <div className='course-bnr-bx bg-7 radius-1'>
                                  <h4 className='course-bnr-title'>100%</h4>
                                  <p className='course-bnr-desc'>Learners became better at their job</p>
                              </div>
                          
                          </div>
                          <div class="col-md-2 align-self-end d-none d-sm-block">
                          <img src={img3} alt=''/>
                          </div>
                      </div>
          </div>
      </section>
      <section className='course-desc p-lg-5 bg-14 pt-5'>
              <div class="container text-center">
                      <div class="row justify-content-around text-center">
                          <div class="col-md p-lg-5">
                                  <h2 className='ws-section_heading pd-03'><span className='font-thin'>Best DFT Training Institute in Bangalore | 
                                  </span> DFT Training Course</h2>
                          </div>
                      </div>
                      <div class="row justify-content-around">
                          <div class="col-md">
                                  <h3 className='pb-3 txt-3'>COURSE DESCRIPTION</h3>
                                  <div className='text-left text-xl'>                       
                                    <p>Design For Testability (DFT) is a specialization in the SOC design cycle, to detect the manufacturing defects in a design. With the increase in size &amp; complexity of chips, facilitated by the advancement of manufacturing technologies, DFT has evolved as a specialization in itself over a period of time. DFT Engineers works on introducing various test structures as part of the design flow, on increasing the testability of logic, memories and interconnects.</p>
                                     <p>DFT training course is designed as per the current industry requirements with multiple hands on projects based on SCAN, ATPG, JTAG and MBIST.</p>

                                  </div>
                          </div>
                      </div>
              </div>
      </section>
      <section className='highlight-section p-lg-5 bg-14 p-2'>
          <div class="container bg-9 p-lg-5 p-3 radius-1">
              <div className='txt-3 mb-3'>Industry Standard VLSI and DFT Training</div>
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Eligibility</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>B.E/B.Tech in ECE/EEE.</div>
                  </div>
                  </div>
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>M.E/M.Tech/M.S in VLSI/Embedded Systems/Digital Electronics.</div>
                  </div>
                  </div>
              </div>
              </div>
              <div className='mb-5'>
              <div className='txt-2 mb-2'>Course Duration</div>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>5 Months</div>
                  </div>
                  </div>
              
              </div>
              </div>
              <div>
              <div className='txt-2 mb-2'>Course Highlights</div>
              <p>By end of this course, the candidate will be able to:</p>
              <div class="row">
                  <div className='col-lg'>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Review, analyse and propose changes to improve testability and implement them by doing Scan,ATPG and Simulations.
                      </div>
                  </div>
              
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Analyse the DRC issues and can be able to find the solution during scan and ATPG.
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Analyse test coverage, propose changes to improve test coverage to achieve the goal with optimal patterns
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Generate the patterns for both stuck-at and at speed testing of the design for optimal test cost.
                      </div>
                  </div>
                  
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Understanding and applying debugging techniques used in debugging test on silicon in simulation environment
                      </div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>24×7 Lab Support with Lab practice handouts and course material delivery.
                      </div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Industry standard project execution with Lab practice and theory sessions under the guidance of industry expert with 12+ years of experience.
                      </div>
                  </div>
                  <div className='icon-left-bx d-flex mb-2'>
                      <div className='icn-img'> <img src={icncheck} alt=''/></div>
                      <div className='icn-heading'>Soft skills development, complete suite of job oriented physical design training with 100% placement assistance
                      </div>
                  </div>
                  
                  </div>
              </div>
              </div>
                  
          </div>
      </section>

      <section className='author-section p-lg-5 p-2 bg-14'>
      <div className='container'>
      <div class="row">
              <div class="col-lg-9 align-self-center bg-3 dark-bg p-lg-5 p-3 mr--10 mt-5 mb-3">
              <h2 class="ws-section_heading mb-3">About Instructors</h2>
              <a href='/teachers/shiva/'><h4>Mr. Siva</h4></a>
              <h6 className='pb-3'>(Specialist Design For Test (DFT))</h6>
              <p>Mr. Siva comes with 12+ years of experience VLSI Industry , with substantial experience in DFT and worked as a Lead Engineer in several product companies. He is passionate about teaching &amp; sharing his knowledge and mentored entry/mid-level engineers throughout his career. We believe his solid knowledge on Digital and Physical Design implementation adopted by industry helps the students to shape themselves as good VLSI engineers.</p>
              <div class="wpb_wrapper">
              <div class="row g-3">
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Expertise Areas:</strong></p>
                      <p>Low power implementation and strategies<br/>
                        Mode specific Design constraints development<br/>
                        Clock Tree Building at Block and Full-Chip<br/>
                        Full-Chip Timing Analysis and Timing Closure<br/>
                        Logical Equivalence Check and Low power checks<br/>
                        SI/Cross_talk analysis</p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>Technology Process Worked On:</strong><br/>
                      <strong>Finfet Technologies:</strong> 7nm and 16nm<br/>
                      <strong>Nominal Technologies:</strong> 28nm, 40nm, 65nm, 90nm &amp; 130nm.</p>
                      <p><strong>IC Foundries Worked with:</strong> TSMC, UMC, GF</p>
                      </div>
                      <div class="col-lg m-lg-3 p-4 bg-white radius-1">
                      <p><strong>EDA tools known for Physical design :</strong> Genus/RTL_Compiler/DC, Conformal, Encounter/Innovus, QRC Extraction, PrimeTime/Tempus<br/>
                      Physical verification tools known: Redhawk/Voltus, Calibre DRC, Calibre LVS</p>
                      </div>
                  </div>
                      </div>
              </div>
              <div class="col-lg img-radius">
              <img src={instimg} alt=''/>
              </div>
          </div>
          </div>
      </section>

      <section className='curriculum-section pt-5'>
          <div className='container'>
              <div class="row justify-content-center mb-5">
              <div class="col-lg-8 text-center">
              <h3 class="ws-section_heading pb-03 txt-3">Best DFT training institute with placement
              </h3>
              </div>
              </div>
              <div class="row mb-5">
                  <div class="col-lg-8">
                  <div class="ws-section_heading pb-03 txt-3 mb-lg-0">Course Curriculum</div>
                  </div>
                  <div class="col-lg-4 align-self-center">
                  <button class="btn-primary btn-icon" onClick={onButtonpdf}>Download Brochure<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                  
                  </div>
              </div>
              <div className='row'>
                  <div className='col-lg'>
                  <div className='curriculum-accord accordion'>
                          <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>Module 1: Introduction to Electronics, MOSFET & CMOS Theory</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction to Electronics and MOSFET Theory</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction to MOSFET Theory</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction to CMOS Process and Circuits </div>
                              </div>
                          </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>Module 2: Digital Electronics</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Binary system and Boolean algebra </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Combinational Circuits</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Sequential circuits - Counters, state machines, shift registers</div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>Module 3: Basics of UNIX/LINUX</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction to Unix/Linux Commands</div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>VI Editor Commands
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>Module 4: Introduction to ASIC Design</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>ASIC Flow </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>All Stages Discussion 
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>Module 5: Introduction to Verilog</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Basic Concepts
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Gate - Level Modeling
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Dataflow Modeling
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Behavioural Modeling Tasks and Functions
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>Module 6: Scan Insertion</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Scan Architecture Overview
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Scan Design Rules
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Discussion on important Scan rules to follow
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Scan constraints discussion
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Scan DRC analysis & fixing
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>STIL protocol file or SPF generation, discussion about SPF
                                  </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Discussion on outputs of Scan insertion flow
                                  </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="6">
                              <Accordion.Header>Module 7: JTAG / Boundary Scan</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>What is JTAG
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Discussion about JTAG architecture
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Understanding JTAG FSM, instructions
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="7">
                              <Accordion.Header>Module 8: Automatic Test Pattern Generation (ATPG)</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Introduction to ATPG & ATPG basics
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Equivalent faults, dominant faults & fault collapsing
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>ATPG algorithms
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="8">
                              <Accordion.Header>Module 9: ATPG Fault Models Fault Classes</Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Discussion of different fault models
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>On chip clock controller discussion
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>At speed ATPG
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>LOC & LOS discussion
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Understanding of different fault classes
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="9">
                              <Accordion.Header>Module 10: Pattern Generation & Simulation
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Generating Stuck at ATPG patterns
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Understanding MaxTB simulation flow
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Simulating Stuck at patterns
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="10">
                              <Accordion.Header>Module 11: Debugging simulation mismatches
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Fixing simulation mismatches
                              </div>
                              </div>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Fault simulation
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="11">
                              <Accordion.Header>Module 12: Industry standard Project Execution
                              </Accordion.Header>
                              <Accordion.Body>
                              <div className='icon-left-bx d-flex mb-2'>
                                  <div className='icn-img'> <FontAwesomeIcon icon="fas fa-dot-circle" /></div>
                                  <div className='icn-heading'>Industry Standard DFT Live Project
                              </div>
                              </div>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="12">
                              <Accordion.Header>Module 13: Mock Interviews & Personality Development
                              </Accordion.Header>
                              
                          </Accordion.Item>
                          
                          </Accordion>
                          </div>
                  </div>
              </div>

          </div>
                  </section>

                  <section className='video-section p-lg-5 pt-4'>
          <div class="container text-center">
              <div className='row'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">DFT Demo Videos</h2>
              </div>
              </div>
              <div class="row justify-content-center">
                  <div class="col-lg-4">
                      <iframe
                          width="100%"
                          height="250"
                          src={`https://www.youtube.com/embed/EMVQbVhoS2A`}
                          frameBorder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                          allowFullScreen
                          title="Embedded youtube"
                          poster="hqdefault"
                      />
                  </div>
                  <div class="col-lg-4">
                  <iframe
                      width="100%"
                      height="250"
                      src={`https://www.youtube.com/embed/sDKpAUXFJYA`}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                      title="Embedded youtube"
                      poster="hqdefault"
                  />
                  </div>
              </div>
          </div>
      </section>


                  <Companysec/>
                  <section className='ws-section pb-5 bg-white'>
                      <div class="container text-center">
                      <div class="row justify-content-around">
                                      <div class="col-lg-6">
                                          <div className='trainer-box mb-3'>
                                          
                                              <div className='trainer-img img-radius'>
                                              <img src={tr1} alt=''/>
                                              </div>
                                          </div>
                                      </div>
                                      <div class="col-lg-6 text-left">
                                          <h2 className='mb-4'>Four Top Reasons Why You Should Take Only Our DFT (Design for Test) Course at Takshila VLSI Institute
                                          </h2>
                                          <p>When it comes to DFT training, we at the Takshila VLSI institute are certainly one of the foremost DFT training institutes in India. DFT – design for testability – is an area of specialization in the cycle of SOC designs, to detect any manufacturing defects that might be present in any design. With the progressively rising complexity and size of chips which, has been greatly facilitated by the great advancement of manufacturing technologies, DFT has come to truly evolve as a specialization of its own through a certain period. The work of DFT engineers is to introduce many varying test structures as a component of any design flow, as regards increasing the testability of memories, logic, as well as interconnect.</p>
                                          <p>As the foremost DFT training institute in Bangalore and our branch also being the foremost of all DFT training institutes in Hyderabad. If you are still in doubt as regards the fact that we are the foremost of all DFT institutes in Bangalore, then read on to discover why you should sign up for our DFT course in Bangalore irrespective of where you might be residing.</p>
                                          <div className='course-accord dark-bg'>
                                      <Accordion defaultActiveKey="0">
                                      <Accordion.Item eventKey="0">
                                          <Accordion.Header>1. The Content of Our Course</Accordion.Header>
                                          <Accordion.Body>
                                          <p>Our design for test training is designed by the best experts according to the most trending industry requirements. Our students are given several hands-on projects that are based on ATPG, MBIST, SCAN, as well as JTAG. This is to ensure that they turn out to be the best DFT engineers that they can be thus establishing their place in the industry quite fast after they have completed their studies. That is what makes us one of the best design for test training institutes in India.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="1">
                                          <Accordion.Header>2. We are the Best Around
                                          </Accordion.Header>
                                          <Accordion.Body>
                                          <p>Yes, that is quite true. We are surely the best design for test training institute in Bangalore and our branch is also the best of all design for test training institutes in Hyderabad. Besides, our course is surely low-cost and probably the most affordable. Experts all agree that we offer a lot more value than what our students pay when you compare the quality of our lessons, teachers, and teaching materials to the amount of money we charge for the course.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="2">
                                          <Accordion.Header>3. The Amazing Highlights of Our DFT Course
                                          </Accordion.Header>
                                          <Accordion.Body>
                                                  <p>As the foremost of all design for test training institutes in Bangalore, we surely offer the most comprehensive as well as the most educating design for test course in Bangalore. The amazing highlights of our amazing DFT course include the fact that by the end of their course our students are quite able to;</p>
                                            <ul>
                                            <li>Analyze, review, as well as propose alterations for the improvement of testability, and also improving such improvements by undertaking ATPG, SCAN, as well as Simulations.</li>
                                            <li>Analyzing all DRC problems and being able to discover and proffer solutions during their SCAN and ATPG procedures.</li>
                                            <li>Analyze the coverage of the test, propose alterations for the improvement of the test coverage to attain intended goals with the most optimal patterns.</li>
                                            <li>Understand and apply debugging techniques and strategies that are used in debugging tests on simulation as well as silicon environments.</li>
                                            <li>24/7 lab support and practice handouts as well as course material delivery.</li>
                                            </ul>
                                         </Accordion.Body>
                                      </Accordion.Item>
                                      <Accordion.Item eventKey="3">
                                          <Accordion.Header>4. Our Placement Program</Accordion.Header>
                                          <Accordion.Body>
                                          <p>We are the best DFT training institute with 100% placement opportunities for all of our students. Our team presently beginning to recognize us as one of the best DFT training institute in India, a low-cost DFT training institute, and the foremost of all the best DFT training institutes in India, due to our amazing placement program. This placement program puts us among the top 10 DFT institutes and enables our students to fully explore their potentials as future DFT engineers and experts who have graduated from one of the India’s top 10 DFT training institutes.</p>
                                          <p>In conclusion, is you compare the value we offer when giving students DFT training with the best tools to what we charge for our online DFT courses, you will agree that we are the best training institute, so sign up for our DFT course online.</p>
                                          </Accordion.Body>
                                      </Accordion.Item>
                                      
                                      </Accordion>
                                      </div>
                                      </div>
                                  </div>
                      </div>
                  </section>
                  
      <Whysec/>           
      <Offersec/>


      <section className='ws-section pb-5 bg-white'>
          <div class="container text-center">
          <div className='row pb-3'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Connect With Us</h2>
              </div>
              </div>
          <div class="row justify-content-around">
                          <div class="col-lg-5">
                              <div className='trainer-box'>
                                  <div className='content-box wd-80 d-flex bg-path'>
                                  <div className='trainer-content'>
                                  <h5 className='trainer-title text-left'>Join us & achieve <br/>
                                  your goals.</h5>
                                  </div>
                                  </div>
                                  <div className='trainer-img img-radius'>
                                  <img src={img4} alt=''/>
                                  </div>
                              </div>
                          </div>
                          <div class="col-lg-6">
                              
                              <iframe
                                  aria-label='Register Now'
                                  width="100%"
                                  height="850"
                                  src={`https://forms.zohopublic.in/takshilavlsi/form/RegisterNow/formperma/tlJf9hR_tSfj9rMVkXThsxg_XdK_F2MPKQIOi3mqwE4`}
                                  frameborder="0" 
                              
                              />
                          
                          </div>
                      </div>
          </div>
      </section>


      <section className='course-faq-section ws-section p-lg-5 bg-14'>
          <div className='container'>
              <div className='row'>
                  <div className='col-lg text-center'>
                  <h2 class="ws-section_heading">Frequently Asked Questions</h2>
              </div>
              </div>
              <div className='row justify-content-center pb-5'>
                  <div className='col-lg-10'>
                  <Accordion defaultActiveKey="0">
                          <Accordion.Item eventKey="0">
                              <Accordion.Header>1. What is the VLSI Design for Test (DFT) course all about?</Accordion.Header>
                              <Accordion.Body>
                                <p>Our <strong>VLSI Design for Test</strong> class explores testing complex chip designs to guarantee they are free of defects. You will be taught how to identify and solve problems in systems on Chips (SoCs) by implementing methods such as SCAN, ATPG, JTAG, and MBIST. Perfect for individuals who want to develop chips with built-in testing capabilities.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="1">
                              <Accordion.Header>2. Who is suitable for the DFT training program?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our <strong>DFT training program</strong> is ideal for individuals who have completed a B.E. or B. Tech in ECE or EEE, or for those who hold a postgraduate degree in VLSI or Embedded Systems or Digital Electronics. If you want to learn advanced testing methods in VLSI and are interested, this course is suitable for you.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="2">
                              <Accordion.Header>3. What can I expect from the Design for Test certification?</Accordion.Header>
                              <Accordion.Body>
                              <p>You will receive the <strong>Design for Test certification</strong> after completing the course, which will confirm your proficiency in Design for Test. It indicates that you have successfully mastered crucial test techniques, such as SCAN and ATPG, and are prepared to confidently take on actual chip design problems.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="3">
                              <Accordion.Header>4. How does the Advanced DFT training differ from basic training?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our <strong>advanced DFT training</strong> develops a deeper understanding of complex testing structures and methods. You will gain practical experience with advanced tools and projects, ensuring you not only have theoretical knowledge about the concepts but are also proficient in applying them to innovative designs.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="4">
                              <Accordion.Header>5. Where can I find Design for Test tutorials and resources?</Accordion.Header>
                              <Accordion.Body>
                              <p>In our course materials, you can access various videos and resources for <strong>Design for Test tutorials</strong>. We provide all the essential resources for learning DFT, such as thorough, 24/7, continuous lab support. Furthermore, our skilled teachers will constantly assist you with any issues you may encounter.</p>
                               </Accordion.Body>
                          </Accordion.Item>
                          <Accordion.Item eventKey="5">
                              <Accordion.Header>6. How does the DFT training program prepare me for the industry?</Accordion.Header>
                              <Accordion.Body>
                              <p>Our <strong>DFT course details</strong> focus on practical knowledge and prepare you for the industry through real projects, real-life situations, and expert advice. You will gain experience from professionals with over 12 years of experience while working on projects that meet industry standards. Furthermore, we provide full support in securing a job in the VLSI design industry to help you achieve your career goals.</p>
                              </Accordion.Body>
                          </Accordion.Item>
                          </Accordion>
                  </div>
              </div>
              <div class="row justify-content-center mt-lg-5">
                      <div class="col-lg-9">
                          <div class="callaction-2">
                              <div class="row">
                              <div class="col-lg-7">
                                  <h2>Don't see your questions ? answered here?</h2>
                              </div>
                              <div class="col-lg-4 align-self-center text-center">
                              <a href="/contact-us/">
                              <button class="btn-primary btn-icon ms-0" href="index.html#about">Contact Us<FontAwesomeIcon icon="fa-solid fa-circle-arrow-right" /></button>
                              </a>
                              </div>
                              </div> 
                          </div>
                      </div>
                  </div>
          </div>
      </section>


      <Videoreview/>
      <Enrollaction/>
      <Partnersec/> 
      </main>
      <Footer/>
      </div>
  )
}

export default DFT